var $dfd0442353374a0e$exports = {};
function $dfd0442353374a0e$var$scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
window.scrollToTop = $dfd0442353374a0e$var$scrollToTop;


//# sourceMappingURL=bi_quyet_giup_con_het_nghien_game_tu_chuyen_gia_Nguyen_Thi_Lanh.049b25d2.js.map
